import { Component} from '@angular/core';

@Component({
  selector: 'app-subs',
  templateUrl: './subs.component.html',
  styleUrls: ['./subs.component.scss']
})
export class SubsComponent{
  subsArr: Array<any> = ["./assets/images/profile-1.jpg","./assets/images/profile-2.jpg","./assets/images/profile-3.jpg","./assets/images/profile-4.jpg","./assets/images/profile-5.jpg","./assets/images/profile-6.jpg","./assets/images/profile-7.jpg","./assets/images/profile-8.jpg","./assets/images/profile-9.jpg","./assets/images/profile-10.jpg","./assets/images/profile-11.jpg","./assets/images/profile-12.jpg","./assets/images/profile-13.jpg","./assets/images/profile-14.jpg","./assets/images/profile-15.jpg","./assets/images/profile-16.jpg","./assets/images/profile-17.jpg","./assets/images/profile-18.jpg","./assets/images/profile-19.jpg","./assets/images/profile-20.jpg","./assets/images/profile-21.jpg","./assets/images/profile-22.jpg"];

}
